import { Component, OnInit, Inject } from '@angular/core';
import { UiService } from '../../services/ui/ui.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router } from '@angular/router';
import { UserManagerService } from 'src/app/services/user-manager/user-manager.service';
import { SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { STORAGE_KEYS } from '@enum/storage-keys.enum';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  constructor(public uiService: UiService,
              private bnIdle: BnNgIdleService,
              private userService: UserManagerService,
              private router: Router,
              @Inject(SESSION_STORAGE) private storage: WebStorageService,
              ) { }

  ngOnInit(): void {
    this.userService.hasPreviouslyLoggedIn = true;
    this.startIdleWatch();
  }
  startIdleWatch() {
    const expireTime = this.userService.getParameter('INT_SESSION_EXPIRATION_TIME_IN_SECONDS')
    ? this.userService.getParameter('INT_SESSION_EXPIRATION_TIME_IN_SECONDS') / 60
    : 5;
    this.userService.idleInterval = setInterval( () => {
     this.userService.userIdleTime = this.userService.userIdleTime + 1;
     if (this.userService.userIdleTime >= expireTime) {
      //  console.log("TIME EXPIRED")
       this.userService.isLoggedIn = false;
       this.userService.userIdleTime = 0;
       this.router.navigate(['/'], {});
       let session={
        'login': this.userService.isLoggedIn,
        'data': this.userService.logindata,
      }
       this.storage.set(STORAGE_KEYS.LOGIN, session);
     }
    }, 60000);
    document.addEventListener('click', () => { this.userService.userIdleTime = 0; });
    document.addEventListener('mousemove', () => { this.userService.userIdleTime = 0; });
    document.addEventListener('keypress', () => { this.userService.userIdleTime = 0; });
    document.addEventListener('change', () => { this.userService.userIdleTime = 0; });
    document.addEventListener('scroll', () => { this.userService.userIdleTime = 0; });
   }
}
